import {
    FETCH_REF_DOCTORS_START, FETCH_REF_DOCTORS_SUCCESS, FETCH_REF_DOCTORS_ERROR, ADD_UPDATE_REF_DOCTOR_START,
    ADD_UPDATE_REF_DOCTOR_SUCCESS,
    DELETE_REF_DOCTOR_SUCCESS,
    DELETE_PROVIDER_LOCATION_SUCCESS,
    FETCH_ALL_REF_DOCTORS_START,
    FETCH_ALL_REF_DOCTORS_SUCCESS,
    FETCH_ALL_REF_DOCTORS_ERROR,
    SET_REF_DOCTORS_PAGINATION
} from "../../actions/receptionist/refDoctorsAction";
import _ from 'lodash';

const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    refDoctors: [],
    allRefDoctors: [],
    pagination: {
        currentPage: 1,
        pageSize: 20,
        totalPages: 0,
        totalItems: 0,
    },
}

const refDoctorsReducer = (state = INIT_STATE, action) => {
    let newState;
    let newRefDoctors;
    let index;
    switch (action.type) {

        case FETCH_REF_DOCTORS_START:
            return { ...state, error: '', message: '', loading: true };

        case FETCH_REF_DOCTORS_SUCCESS:
            newState = _.cloneDeep(state);
            return { ...newState, error: '', message: '', loading: false, refDoctors: _.cloneDeep(action.refDoctors) };

        case FETCH_REF_DOCTORS_ERROR:
            newState = _.cloneDeep(state);
            return { ...newState, error: '', message: '', loading: false, };

        case SET_REF_DOCTORS_PAGINATION: 
            return { ...state, error: '', message: '', pagination: { ...action.pagination } };
        
        case ADD_UPDATE_REF_DOCTOR_START:
            return { ...state, error: '', message: '', loading: true };


        case ADD_UPDATE_REF_DOCTOR_SUCCESS:
            newState = _.cloneDeep(state);
            index = newState.refDoctors.findIndex(refDoctor => refDoctor.refDrId === action.refDoctor.refDrId);
            let allRefDoctorIndex = newState.allRefDoctors.findIndex(refDoctor => refDoctor.refDrId === action.refDoctor.refDrId);

            if (allRefDoctorIndex === -1) {
                newState.allRefDoctors.push(action.refDoctor)
            } else {
                newState.allRefDoctors[allRefDoctorIndex] = _.cloneDeep(action.refDoctor);
            }
            if (index === -1) {
                newState.refDoctors.push(action.refDoctor);
                return { ...newState, error: '', message: '', loading: false, };
            } else {
                newState.refDoctors[index] = _.cloneDeep(action.refDoctor);
                return { ...newState, error: '', message: '', loading: false, };
            }

        case DELETE_REF_DOCTOR_SUCCESS:
            newState = _.cloneDeep(state);
            newState.refDoctors = newState.refDoctors.filter(refDoctor => refDoctor.refDrId !== action.refDrId)
            return { ...newState }
        case DELETE_PROVIDER_LOCATION_SUCCESS:
            newState = _.cloneDeep(state);
            index = newState.refDoctors.findIndex(refDoctor => refDoctor.refDrId === action.refDoctor.refDrId);

            if (index === -1) {
                return { ...newState, error: '', message: '', loading: false, };
            } else {
                let selectedRefDoctor = newState.refDoctors[index];
                selectedRefDoctor.providerLocations = selectedRefDoctor.providerLocations.filter(providerLocation => providerLocation.providerLocationId !== action.refDoctor.providerLocationId)
                newState.refDoctors[index] = _.cloneDeep(selectedRefDoctor);
                return { ...newState, error: '', message: '', loading: false, };
            }

        case FETCH_ALL_REF_DOCTORS_START:
            return { ...state, error: '', message: '', loading: true };

        case FETCH_ALL_REF_DOCTORS_SUCCESS:
            newState = _.cloneDeep(state);
            return { ...newState, error: '', message: '', loading: false, allRefDoctors: _.cloneDeep(action.allRefDoctors) };

        case FETCH_ALL_REF_DOCTORS_ERROR:
            newState = _.cloneDeep(state);
            return { ...newState, error: '', message: '', loading: false, allRefDoctors: [] };

        default: return state;
    }
}

export default refDoctorsReducer;